import Utilities from '@util/Utilities';
import Tag from '@app/component/tag/Tag';
import React from 'react';
import CompanyHotel from '@app/model/company_hotel/CompanyHotel';
import AlertExecution from '@app/model/alert/AlertExecution';
import CompetitorsPriceRateAlertExecutionNotificationOutput
	from '@app/model/alert/output/CompetitorsPriceRateAlertExecutionNotificationOutput';

const CompetitorsPriceRateNotificationRowFragment: React.FunctionComponent<{
	companyHotel: CompanyHotel,
	alertExecution: AlertExecution,
	notificationOutput: CompetitorsPriceRateAlertExecutionNotificationOutput
}> = ({ companyHotel, alertExecution, notificationOutput }) => {


	const findCompetitor = (competitorId: number) => {
		return alertExecution.alertOutput.competitors!.find(c => c.id === competitorId);
	};

	const displayAverage = (average: number, title: string) => {
		return <>
			<span className="font-light text-gray-900 mr-1">{title}:</span>
			{average > 0 && <span
				className="font-bold text-green-500">+{Utilities.formatDouble(average * 100, 0)}%</span>}
			{average < 0 && <span
				className="font-bold text-red-500">{Utilities.formatDouble(average * 100, 0)}%</span>}
		</>;
	};

	return <tbody className="divide-y divide-gray-200" key={notificationOutput.notificationId}>
	<tr className="bg-gray-100">
		<td colSpan={2}
				className="whitespace-nowrap py-1.5 pl-4 pr-3 sm:pl-0 text-sm font-bold text-gray-900">
			<span className="mx-1">•</span>
			<span>{Utilities.formatDateString(notificationOutput.statDate, 'ddd DD MMM')}</span>
		</td>
		<td colSpan={3} className="whitespace-nowrap px-2 py-1.5 text-sm text-right">
			{displayAverage(notificationOutput.average, 'Average Change')}
		</td>
	</tr>
	{notificationOutput.competitorPriceRateChanges.map(change => {
		return <tr key={change.competitorId}>
			<td className="whitespace-normal py-3 pl-4 pr-3 sm:pl-0 text-sm text-gray-900">
				{findCompetitor(change.competitorId)?.name}
				{change.isNew &&
					<span className="text-xs text-blue-600 ml-1">• New</span>}
				{change.isUpdated &&
					<span className="text-xs text-blue-600 ml-1">• Updated</span>}
			</td>
			<td className="whitespace-nowrap px-2 py-3 text-sm">
				{Utilities.snakeCaseToWords(change.current.fromRoomType)}
			</td>
			<td className="whitespace-nowrap px-2 py-3 text-sm">
				<span>{Utilities.formatDouble(change.current.from, 0)}</span>
				<span className="mx-1">→</span>
				<span>{Utilities.formatDouble(change.current.to, 0)}</span>
			</td>
			<td className="whitespace-normal py-3 pl-4 pr-3 sm:pl-0 text-sm">
				{change.current.fromRoomName}
				{change.current.fromRoomName === change.current.toRoomName && <><br /><span className="text-gray-400 italic">(Same Room)</span></>}
				{change.current.fromRoomName !== change.current.toRoomName && <><br /><span
					className="mx-1">→</span>{change.current.toRoomName}</>}
			</td>
			<td className="whitespace-nowrap px-2 py-3 text-sm gap-x-3 flex">
				{change.current.rate > 0 &&
					<Tag state="success">+{Utilities.formatDouble(change.current.rate * 100, 0)}%</Tag>}
				{change.current.rate < 0 &&
					<Tag state="critical">{Utilities.formatDouble(change.current.rate * 100, 0)}%</Tag>}
			</td>
		</tr>;
	})}
	</tbody>;
};

export default CompetitorsPriceRateNotificationRowFragment;